import { Component, EventEmitter, Output } from "@angular/core";
import { FileSelectEvent } from "primeng/fileupload";

@Component({
  selector: "app-logo-upload",
  templateUrl: "./logo-upload.component.html",
  styleUrls: ["./logo-upload.component.scss"]
})
export class LogoUploadComponent {
  @Output() data = new EventEmitter<FormData>();

  logo = new FormData();

  selectFile(event: FileSelectEvent) {
    const file = event.currentFiles[0];

    if (!file) return this.logo.delete("arquivo");

    this.logo.set("arquivo", file);
  }

  onUpload() {
    this.data.emit(this.logo);
  }
}
